
import Menu from "../../../assets/duotone/Menu.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MenuIcon({ className, dataTestid = "MenuIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Menu data-testid={dataTestid} className={classes} {...rest} />
  );
}
